import React from 'react';
import PropTypes from 'prop-types';

const SettingsForms = (props) => {
  const { pages, ...rest } = props;
  return (
    <div className="grb-settings-form-ctnr">
      {pages.map((page) => {
        return (
          <SettingsForm
            {...rest}
            key={page.id}
            id={page.id}
            Component={page.Component}
            configuration={page.configuration}
            errors={page.errors || null}
            pages={page.children}
          />
        );
      })}
    </div>
  );
};

SettingsForms.propTypes = {
  pages: PropTypes.arrayOf(PropTypes.shape({
    Component: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({}),
    ]).isRequired,
    configuration: PropTypes.shape({}).isRequired,
    children: PropTypes.arrayOf(PropTypes.shape({})),
  })).isRequired,
};

const SettingsForm = (props) => {
  const { Component, pages, ...rest } = props;
  return (
    <Component
      {...rest}
    >
      {!!pages && !!pages.length && (
        <SettingsForms
          {...rest}
          pages={pages}
        />
      )}
    </Component>
  );
};

SettingsForm.propTypes = {
  Component: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({}),
  ]).isRequired,
  configuration: PropTypes.shape({}).isRequired,
  pages: PropTypes.arrayOf(PropTypes.shape({})),
  search: PropTypes.string,
};

SettingsForm.defaultProps = {
  pages: [],
  search: undefined,
};

export { SettingsForm, SettingsForms };
